// extracted by mini-css-extract-plugin
export default {"labelDotsContainer":"LabelDots-module__labelDotsContainer--sNiXI","labelDot":"LabelDots-module__labelDot--MZUOf"};